import React from "react";
import { Box, useTheme } from "@mui/material";
import Typography from "components/basic/typography";

import TicketRow from "./components/TicketRow";
import { SupportTicket } from "../../types";

interface TicketListProps {
  tickets: SupportTicket[];
  emptyText: string;
  // Admins see who asked; requesters only ever see their own tickets.
  showRequester?: boolean;
  onSelect: (ticket: SupportTicket) => void;
}

const TicketList: React.FC<TicketListProps> = ({
  tickets,
  emptyText,
  showRequester = false,
  onSelect,
}) => {
  const theme = useTheme();

  if (tickets.length === 0) {
    return (
      <Box p={4} textAlign="center">
        <Typography
          variant="body2"
          style={{ color: theme.palette.text.secondary }}
        >
          {emptyText}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {tickets.map((ticket) => (
        <TicketRow
          key={ticket.id}
          ticket={ticket}
          showRequester={showRequester}
          onClick={() => onSelect(ticket)}
        />
      ))}
    </Box>
  );
};

export default TicketList;
